import React from "react";
import { HashLink } from "react-router-hash-link";
import { Row, Col } from "react-bootstrap";
import ActionButton from "./ActionButton";
import { useHistory } from "react-router";

import Styles from "./Footer.module.css";

import FacebookIcon from "../../../src/icons/facebook-icon.svg";
import LinkedInIcon from "../../../src/icons/linkedin-icon.svg";
import InstagramIcon from "../../../src/icons/instagram-icon.svg";
import GitHubIcon from "../../../src/icons/github-icon.svg";
import TwitterIcon from "../../../src/icons/twitter-icon.svg";
import WhatsAppIcon from "../../../src/icons/whatsapp-icon.svg";

function Footer(props) {
  var history = useHistory();
  return (
    <footer>
      <Row className="footer-body">
        <Col xl={3} lg={4} md={6}>
          <div className={Styles.FooterSegment}>
            {" "}
            <Row>
              <p className="email-link">kmatamando@gmail.com</p>
            </Row>
            <Row>
              {/* <Col>
                <SocialIcon
                  url={InstagramIcon}
                  link="https://www.instagram.com/code.the.dream/"
                  alt="Instagram Icon"
                />
              </Col> */}
              {/* <Col>
                <SocialIcon
                  url={FacebookIcon}
                  link="https://www.facebook.com/people/Matamando-Kalilani/100008311455220/"
                  alt="Facebook Icon"
                />
              </Col> */}
              <Col>
                <SocialIcon
                  url={TwitterIcon}
                  link="https://twitter.com/Mata00616"
                  alt="Twitter Icon"
                />
              </Col>
              <Col>
                <SocialIcon
                  url={GitHubIcon}
                  link="https://github.com/MatamandoKalilani"
                  alt="GitHub Icon"
                />
              </Col>
              <Col>
                <SocialIcon
                  url={LinkedInIcon}
                  link="https://www.linkedin.com/in/matamando-kalilani-ab5210161/"
                  alt="LinkedIn Icon"
                />
              </Col>
            </Row>
          </div>
        </Col>
        <Col xl={3} lg={4} md={6}>
          <div className={Styles.FooterSegment}>
            {" "}
            <Row>
              <FooterLink label="Privacy Policy" route="/privacy-policy#top" />
            </Row>
            <Row>
              <FooterLink
                label="Terms & Conditions"
                route="/terms-and-conditions#top"
              />
            </Row>
            <Row>
              <FooterLink label="Refund Policy" route="/refund-policy#top" />
            </Row>
          </div>
        </Col>
        <Col xl={3} lg={4} md={6}>
          <div className={Styles.FooterSegment}>
            {" "}
            <Row>
              <FooterLink
                label="Mobile Development"
                route="/projects/mobile-development#top"
              />
            </Row>
            <Row>
              <FooterLink
                label="Web Development"
                route="/projects/web-development#top"
              />
            </Row>
            <Row>
              <FooterLink
                label="Software Development"
                route="/projects/software-development#top"
              />
            </Row>
          </div>
        </Col>
        <Col xl={2} lg={4} md={6}>
          <div className={Styles.FooterSegment}>
            <Row style={{ marginBottom: "20px" }}>
              <Col>
                <ActionButton
                  styles={{ marginLeft: "0px" }}
                  label="Contact Me"
                  icon="email"
                  onClick={() => {
                    history.push("/contact-me");
                  }}
                />
              </Col>
            </Row>
            {/* <Row>
              <Col>
                {" "}
                <div className="contact-button" style={{ marginLeft: "0px" }}>
                  <p>WhatsApp</p>
                  <img
                    style={{ marginLeft: "7px" }}
                    src={WhatsAppIcon}
                    height="24px"
                    alt="WhatsApp Icon"
                  />
                </div>
              </Col>
            </Row> */}
          </div>
        </Col>
      </Row>
      <Row className="remove-row-margins">
        <div className="footer-divider"></div>
      </Row>
      <Row className="copyright-tag">
        <Col>Copyright © Matamando Kalilani. All rights reserved.</Col>
      </Row>
    </footer>
  );
}

function FooterLink(props) {
  return (
    <HashLink style={{ textDecoration: "none" }} smooth to={props.route}>
      {" "}
      <p className="link">{props.label}</p>
    </HashLink>
  );
}

function SocialIcon(props) {
  return (
    <a href={props.link} target="_blank" rel="noopener noreferrer">
      <img className="social-icon" src={props.url} alt={props.alt} />{" "}
    </a>
  );
}

export default Footer;
